import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import testimonialsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/testimonialsStyle.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

//pics
import cardProfile1Square from "assets/img/jenniferJackman.jpg";
import dg2 from "assets/img/teachers3.jpg";

//icons
import FormatQuote from "@material-ui/icons/FormatQuote";

class TestimonialsSection extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    
    return (
      <div className="cd-section" {...rest}>
        <div
          className={`${classes.testimonials} ${classes.sectionImage}`}
          style={{ backgroundImage: `url(${dg2})` }}
        >
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Card testimonial className={classes.card1}>
                  <div className={classes.icon}>
                    <FormatQuote />
                  </div>
                  <CardBody>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <h5 className={classes.cardDescription} style={{textAlign:"justify", color:"#545454"}}>
                          As a principal, I was looking for a program that was not another “anti-bullying” program but a proactive social-emotional program. All Things EQ is just that.  Parents are emailed the same message the students hear at school and have remarked that this program helps set the tone at home as well!  Teachers report that All Things EQ have helped create an encouraging and self-reliant atmosphere in their classroom without having “one more thing” to do. 
                        </h5>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <h5 className={classes.cardDescription} style={{textAlign:"justify", color:"#545454"}}>All Things EQ takes care of EVERYTHING. As a principal, having a shared culture and language throughout our entire school, from the nurse’s office to the kindergarten classroom, from the cafeteria to the PE soccer field has been a game changer. I have incorporated All Things EQ into my discussions with students when they are referred to me for behavioral referrals. It has been an effective use of our tax credit donations.</h5>
                      </GridItem>
                    </GridContainer>
                  </CardBody>
                  <CardFooter testimonial>
                    <h4 className={classes.cardTitle}>Jennifer Jackman, MPA</h4>
                    <h6 className={classes.cardCategory}>Principal, Bright Beginnings Elementary School</h6>
                    <br />
                    <CardAvatar testimonial testimonialFooter>
                      <a href="#pablo" onClick={e => e.preventDefault()}>
                        <img src={cardProfile1Square} alt="..." />
                      </a>
                    </CardAvatar>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(testimonialsStyle)(TestimonialsSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionBrightBeginnings.jsx